import { getErrorAction } from './errorMapper'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const EDITOR_LOAD = 'EDITOR_LOAD'
export const EDITOR_DEFS_LOAD_SUCCESS = 'EDITOR_DEFS_LOAD_SUCCESS'
export const EDITOR_DEFS_LOAD_FAILURE = 'EDITOR_DEFS_LOAD_FAILURE'
export const EDITOR_UPDATE_DEFS = 'EDITOR_UPDATE_DEFS'
export const EDITOR_SET_CURRENT_BOARD = 'EDITOR_SET_CURRENT_BOARD'
export const EDITOR_LOAD_DEFS_LIST = 'EDITOR_LOAD_DEFS_LIST'

// Action Creators
export const editorLoad = () => ({ type: EDITOR_LOAD })
export const editorDefsLoadSuccess = payload => ({ type: EDITOR_DEFS_LOAD_SUCCESS, payload })
export const editorDefsLoadFailure = payload => ({ type: EDITOR_DEFS_LOAD_FAILURE, payload, error: true })
export const editorUpdateDefs = newDefs => ({ type: EDITOR_UPDATE_DEFS, payload: newDefs })
export const editorSetCurrentBoard = board => ({ type: EDITOR_SET_CURRENT_BOARD, payload: board })
export const editorLoadDefsList = defsList => ({ type: EDITOR_LOAD_DEFS_LIST, payload: defsList })

// Epics
export const editorLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(EDITOR_LOAD),
    mergeMap(action =>
      vapiClient.getBoardDefs().pipe(
        map(ajaxResponse => editorDefsLoadSuccess(ajaxResponse.response)),
        catchError(error => of(getErrorAction(error, editorDefsLoadFailure)))
      )
    )
  )

// Reducer
const editorLoadDefsReducer = (state, boardDefs) => ({
  ...state,
  boardDefsList: [ ...boardDefs ],
  boardDefs: boardDefs.reduce((o, def) => {
    o[def.id] = def
    return o
  }, {})
})
const editorUpdateDefsReducer = (state, boardDefs) => ({
  ...state,
  boardDefsList: Object.keys(boardDefs).map(k => boardDefs[k]),
  boardDefs
})
const editorDefsLoadFailureReducer = (state, error) => ({ ...state, boardDefsList: [], boardDefs: {}, error })
const editorSetCurrentBoardReducer = (state, currentBoard) => ({ ...state, currentBoard })

const editorHandlerMapping = {
  [EDITOR_DEFS_LOAD_SUCCESS]: editorLoadDefsReducer,
  [EDITOR_LOAD_DEFS_LIST]: editorLoadDefsReducer,
  [EDITOR_UPDATE_DEFS]: editorUpdateDefsReducer,
  [EDITOR_DEFS_LOAD_FAILURE]: editorDefsLoadFailureReducer,
  [EDITOR_SET_CURRENT_BOARD]: editorSetCurrentBoardReducer
}

const editorInitialState = {}
export const editorReducer = createReducer(editorInitialState, editorHandlerMapping)

export default editorReducer



// WEBPACK FOOTER //
// ./src/store/editor.js